// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ButtonDownload_buttonContainer__85kbf","buttonIcon":"ButtonDownload_buttonIcon__felH8"};